import React, { useCallback, useEffect, useState, useRef, useLayoutEffect } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import SignUp from "./signup/SignUp";

// import KakaoBalloonImage from "/public/kakao_logo.png";
import GoogleFontImage from "./imgs/google_logo.png";

import googleImage from "./imgs/google_login.png"

import BackImg from "../../assets/uxnicon/9.png";
import TitleImg from "../../assets/uxnicon/8.png";
import "./login.scss";
import {
  agmsClientLoginPost,
  agmsClientRequestGet,
  agmsClientConfirmGet,
  agmsClientRequestPost,
  apiWithoutPortUrl
} from "../../apis/request";
import jwt_decode from "jwt-decode";
import FindIdModal from "./FindIdModa2l";
import TermAgreement from "./TermAgreement";
import ChangePWModal from "./ChangePWModal";
import NoPw from "../../assets/uxnicon/nopw.png";
import OkPw from "../../assets/uxnicon/okpw.png";
import moment from "moment";
import ResetPasswordDialog from "./ResetPasswordDialog";

import { useRecoilValue, useSetRecoilState, useRecoilState} from "recoil";
import { termAllAgree, annotationChartYAxisAtom } from "../../states/recoilState";

import UXNBackgroundImage from "./imgs/login_background_img_small_small.png";
import KakaoButtonImage from "./imgs/kakao_login_medium_narrow.png";
import TextField from '@mui/material/TextField';

import secureLocalStorage from "react-secure-storage";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { useTranslation } from "react-i18next";
import { Modal } from "bootstrap";


const Login = (props) => {
  const { t:translate, i18n } = useTranslation();

  const [loginId, setLoginId] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [userCall, setUserCall] = useState("");
  const [birthday, setBirthday] = useState("");
  const [hosCall, setHosCall] = useState("");
  const [isPassword, setIsPassword] = useState(false);
  const [logInUp, setLogInUp] = useState(false);
  const [findId, setFindId] = useState(false);
  const [changePW, setChangePW] = useState(false);
  const [rememberID, setRememberID] = useState(false);
  const [autoLoginCheck, setAutoLoginCheck] = useState(false);
  const history = useHistory();
  const localEmail = secureLocalStorage.getItem("localEmail");
  const autoLogin = secureLocalStorage.getItem("autoLogin");
  const [termAgreement, setTermAgreement] = useState(false);

  const [annotationChartYAxis, setAnnotationChartYAxis] = useRecoilState(annotationChartYAxisAtom);

  const termAllAgreeInfo = useRecoilValue(termAllAgree);
  const setTermAllAgreeInfo = useSetRecoilState(termAllAgree);

  const location = useLocation();
  const oauthInput = location.state?.oauthInput;
  
  const forceModalRef = useRef(null);
  const forceModalInstanceRef = useRef(null);

  ///////////////////////////
  useEffect(() => {
    if (!forceModalRef.current) return;

    // Bootstrap Modal 인스턴스 생성 (1회)
    forceModalInstanceRef.current =
      forceModalInstanceRef.current || new Modal(forceModalRef.current, {
        backdrop: "static", // 바깥 클릭시 닫히게 하려면 true
        keyboard: true,     // ESC로 닫기
        focus: true,
      });

    return () => {
      // 언마운트 시 정리
      forceModalInstanceRef.current?.dispose?.();
      forceModalInstanceRef.current = null;
    };
  }, []);

  const openForceModal = (e) => {
    // e.preventDefault();
    forceModalInstanceRef.current?.show();
  };

  const closeForceModal = () => {
    forceModalInstanceRef.current?.hide();
  };

  const onConfirmForceLogin = async (e) => {
    await clickSignInForce(e);
    forceModalInstanceRef.current?.hide();
  };
  ///////////////////////////

  useEffect(() => {
    // if (oauthInput !== null && oauthInput !== undefined) {
    //   setLogInUp(true);
    //   console.log(oauthInput);
    // }
    if(secureLocalStorage.getItem('oauthData') !== null && secureLocalStorage.getItem('oauthData') !== undefined){
      setLogInUp(true);
    }
  }, [location.pathname]);

  /**
  *
  * @date     2023.02.03
  * @brief    회원가입 버튼 클릭 이벤트 함수
  * @details  이메일 정보로 회원 가입 후 인증 메일 발송 - 메일 인증 후 가입 완료
  * @param   
  * @return   
  *
  */
  //let result = await agmsClientRequestPost(`/api/staff/join` , secureLocalStorage.getItem("refreshtoken"));
  const handleRememberIdClick = () => {  
    setRememberID(!rememberID);    
  }

  /**
  *
  * @date     2023.02.03
  * @brief    로그인 버튼 클릭 이벤트 함수
  * @details  로그인 시도 및 다중 로그인 체크
  * @param    res1.currentWebLoginCount - 다른곳 로그인 여부 확인(서버에서 받아 옴)
  * @param    res1.loginOtherIp - 먼저 로그인 된 IP 정보
  * @return   
  *
  */
  const onClickGoogleLogin = async () => {
    window.location.href = "https://agmsview.kr:8080/oauth2/authorization/google";
  }
  
  const clickSignIn = async (e) => {
    e.preventDefault();
    try {
      //이메일이 비어있을 때
      if(loginId.trim() === '' || loginId === null || loginId === undefined){
        alert(translate('enter_email'));
        return;
      }
      //비밀번호가 비어있을 때
      if(loginPassword.trim() === '' || loginPassword === null || loginPassword === undefined){
        alert(translate('enter_password'));
        return;
      }


      let body = {
        email: loginId,
        password: loginPassword,
        device: 1,
        is_forced: false
      }
      //let res = await loginPost(`/api/v1/login`, body);
      
      //로그인 (access와 refresh 토큰을 받아온다.)
      let loginResult = await agmsClientLoginPost(`/api/login`, body);
      if(loginResult === null){
        alert(translate('login_failed'));
      }
      else if(loginResult === ''){
        alert(translate('login_failed'));
      }
      secureLocalStorage.setItem('accesstoken', loginResult.access_token);
      window.dispatchEvent(new Event("token-updated"));
      secureLocalStorage.setItem('role', loginResult.role);
      secureLocalStorage.setItem('refreshtoken', loginResult.refresh_token);
      secureLocalStorage.setItem("authUser", loginResult.id);
      secureLocalStorage.setItem("email", loginResult.Email);
      secureLocalStorage.setItem("logoutTrigger",false);
      setAnnotationChartYAxis(
        {
          min: 0,
          max: 30
        },
      );

      if( loginResult.access_token !== null && loginResult.access_token !== undefined ) {
		  secureLocalStorage.setItem('oauthType', 1803);
        history.push("/patient/list", {
          isAfterLogin: true,
        });
      }
      
    } 
    catch (error) {
      if (error.response?.status === 416) {
        alert(translate('try_find_password'));
      } 
      else if (error.response?.status === 415) {
        alert(translate('already_registered_email'));
      }
      else if (error.response?.status === 412) {
        alert(translate('email_verification_expired'));
      } 
      else if(error.response?.status === 409) {
        openForceModal();
      }
      else if(error.response?.status === 410){
        if(error.response.data.result_code === 1004){
          alert(translate('password_reset_expired'));
        }
        
        return;
      }
      // else if (error.response?.status === 410) {
      //   alert("회원 인증 기간이 만료되었습니다.\n계정 메일로 보낸 재 인증 링크를 클릭하여 기간 연장 후 사용해 주세요.");
      // } 
      else if (error.response?.status === 401) {
        if(error.response.data.result_code === 1002){
          alert(translate('login_not_possible'));
        }else if(error.response.data.result_code === 1003){
          alert(translate('password_mismatch_exceeded'));
        }
        
      } else {
        alert(translate('unable_to_login'));
      }
    }
  };

   const clickSignInForce = async (e) => {
    e.preventDefault();
    try {
      //이메일이 비어있을 때
      if(loginId.trim() === '' || loginId === null || loginId === undefined){
        alert(translate('enter_email'));
        return;
      }
      //비밀번호가 비어있을 때
      if(loginPassword.trim() === '' || loginPassword === null || loginPassword === undefined){
        alert(translate('enter_password'));
        return;
      }


      let body = {
        email: loginId,
        password: loginPassword,
        device: 1,
        is_forced: true
      }
      //let res = await loginPost(`/api/v1/login`, body);
      
      //로그인 (access와 refresh 토큰을 받아온다.)
      let loginResult = await agmsClientLoginPost(`/api/login`, body);
      if(loginResult === null){
        alert(translate('login_failed'));
      }
      else if(loginResult === ''){
        alert(translate('login_failed'));
      }
      secureLocalStorage.setItem('accesstoken', loginResult.access_token);
      window.dispatchEvent(new Event("token-updated"));
      secureLocalStorage.setItem('role', loginResult.role);
      secureLocalStorage.setItem('refreshtoken', loginResult.refresh_token);
      secureLocalStorage.setItem("authUser", loginResult.id);
      secureLocalStorage.setItem("email", loginResult.Email);
      secureLocalStorage.setItem("logoutTrigger",false);
      setAnnotationChartYAxis(
        {
          min: 0,
          max: 30
        },
      );

      if( loginResult.access_token !== null && loginResult.access_token !== undefined ) {
		  secureLocalStorage.setItem('oauthType', 1803);
        history.push("/patient/list", {
          isAfterLogin: true,
        });
      }
     
      
    } 
    catch (error) {
      if (error.response?.status === 416) {
        alert(translate('try_find_password'));
      } 
      else if (error.response?.status === 415) {
        alert(translate('already_registered_email'));
      }
      else if (error.response?.status === 412) {
        alert(translate('email_verification_expired'));
      } 
      else if(error.response?.status === 409) {
        alert("해당 계정으로 로그인 한 다른 기기가 있습니다. 해당 기기를 로그아웃하고 로그인 하시겠습니까?");
      }
      else if(error.response?.status === 410){
        if(error.response.data.result_code === 1004){
          alert(translate('password_reset_expired'));
        }
        
        return;
      }
      // else if (error.response?.status === 410) {
      //   alert("회원 인증 기간이 만료되었습니다.\n계정 메일로 보낸 재 인증 링크를 클릭하여 기간 연장 후 사용해 주세요.");
      // } 
      else if (error.response?.status === 401) {
        if(error.response.data.result_code === 1002){
          alert(translate('login_not_possible'));
        }else if(error.response.data.result_code === 1003){
          alert(translate('password_mismatch_exceeded'));
        }
        
      } else {
        alert(translate('unable_to_login'));
      }
    }
  };




   //function : 비밀번호 찾기 버튼 클릭 이벤트 함수
  const onChangePassword = (e) => {
    const passwordRegex =
      /^(?=.*[a-zA-Z])(?=.*[!@%$%^&*()+=._-])(?=.*[0-9]).{8,35}$/;
    const passwordCurrent = e.target.value;
    setLoginPassword(passwordCurrent);
    if (!passwordRegex.test(passwordCurrent)) {
      setIsPassword(false);
    } else {
      setIsPassword(true);
    }
    if (passwordCurrent.length === 0) {
      setIsPassword(false);
    }
  };


  useEffect(()=>{
  },[logInUp])

  //아이디 기억하기 useEffect
  useEffect(() => {
    if (rememberID) {
      secureLocalStorage.setItem("localEmail", loginId);
    } 
    else if (!rememberID) {
      secureLocalStorage.removeItem("localEmail");
    }
  }, [rememberID]);

  useEffect(() => {
    if (userCall.length === 10) {
      setUserCall(userCall.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"));
    }
    if (userCall.length === 13) {
      setUserCall(
        userCall.replace(/-/g, "").replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
      );
    }
  }, [userCall]);

  const handleHosPhonePress = (e) => {
    const regex = /^[0-9\b -]{0,13}$/;
    if (regex.test(e.target.value)) {
      setHosCall(e.target.value);
    }
  };

  // useEffect 함수 - 2번째 인자의 값이 변하면 함수의 내용이 실행된다.
  useEffect(() => {
    if (hosCall.length === 10) {
      setHosCall(hosCall.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"));
    }
    if (hosCall.length === 13) {
      setHosCall(
        hosCall.replace(/-/g, "").replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
      );
    }
  }, [hosCall]);

  const handleBirthPress = (e) => {
    const regex = /^[0-9\b -]{0,10}$/;
    if (regex.test(e.target.value)) {
      setBirthday(e.target.value);
    }
  };

  useEffect(() => {
    if (birthday.length === 8) {
      setBirthday(birthday.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"));
    }
    if (birthday.length === 10) {
      setBirthday(
        birthday.replace(/-/g, "").replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
      );
    }
  }, [birthday]);

  useEffect(() => {
    if (localEmail) {
      setLoginId(localEmail);
      setRememberID(true);
    }
  }, [localEmail]);


  //새로고침 시에 input에 focus주기
  const emailFieldRef = useRef(null);
  const passwordFieldRef = useRef(null);
  const buttonRef= useRef(null);
 
  //mount UseEffect
  useEffect(() => {
    secureLocalStorage.setItem('isLoginPage', true);
    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    setTermAllAgreeInfo({
      agree: false
    });

    //아이디 기억하기 체크
    //로컬에 저장된localEmail이 있으면    
    if(secureLocalStorage.getItem('localEmail') !== null){
      //체크 표시해주고
      setRememberID(true);
      //아이디 입력창에 기억된 아이디 넣어주기
      setLoginId(secureLocalStorage.getItem('localEmail'));
    }

    //자동 로그인 체크
    //로컬에 저장된 autoLogin이 있으면
    if(secureLocalStorage.getItem('autoLogin') !== null){
      //체크 표시
      setAutoLoginCheck(true);
    }else{
     
    }
  },[]);


  // 약관동의 체크박스 관련 - add 2023-04-26, ykw
  // const [allCheck, setAllCheck] = useState(false);

  // const allBtnEvent =()=>{
  //   if(allCheck === false) {
  //     setAllCheck(true);
  //   }else {
  //     setAllCheck(false);
  //   } 
  // };

  //로그인 화면 전환 시 이용 약관 동의를 다시 해야함
  const setLogInUpState =(setValue)=>{
    if(setValue === true){
      setLogInUp(true);
      setTermAllAgreeInfo({ agree: "false" });//이용 약관 동의여부 false

    }
    else{
      setLogInUp(false);
      setTermAllAgreeInfo({ agree: "false" });//이용 약관 동의여부 false
    }
  }

  //회원가입 클릭 
  const onClickSignUp = () => {
    secureLocalStorage.setItem("oauthData", null);
    setLogInUp(true)
  }
  
	const onClickKakao = () => {

		secureLocalStorage.setItem('oauthType', 1802);
	}

	const onClickGoogle = () => {
		secureLocalStorage.setItem('oauthType', 1801);
	}

	const [openRestPassword, setOpenResetPassword] = useState(false);
	
	const handleResetPasswordOpen = () => {
		setOpenResetPassword(true);
	}
	const handleClose = (value) => {
		setOpenResetPassword(false);
		//setSelectedValue(value);
	};

  return (
    <React.Fragment>
      <div
        style={{
          position: "fixed",
          top: 16,
          right: 16,
          zIndex: 9999,
          display: "flex",
          gap: 8,
        }}
      >
        <button
          type="button"
          onClick={() => i18n.changeLanguage("ko")}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #d0d0d0",
            background: "rgba(255,255,255,0.85)",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          한국어
        </button>

        <button
          type="button"
          onClick={() => i18n.changeLanguage("en")}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #d0d0d0",
            background: "rgba(255,255,255,0.85)",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          English
        </button>
      </div>

      <div
        className="row m-0 p-0"
        style={{ display: "flex", justifyContent: "end", overflow:'hidden',}}
      >
        <div
          className="col-lg-8 d-none d-lg-block m-0 p-0"
          style={{ position: "fixed", left: 0 ,}}
        >
          <img src={UXNBackgroundImage} style={{ width: "100%", height: "100vh" }} />
        </div>
        
        <div
          className="col-lg-4 d-flex flex-column align-items-center justify-content-center m-0"
          style={{
            minHeight: "100vh",
            padding: "0px 20px",
            backgroundColor:'#ffffff',
            //backgroundColor:'blue',
            overflow:'hidden',
          }}
        >
          {logInUp ? (
			<SignUp 
				logInUp={logInUp}  
				setLogInUp={setLogInUp}
				termAgreement={termAgreement}
				setTermAgreement={setTermAgreement}/>
          ) : (
            <form
              className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
              onSubmit={clickSignIn}
            >
				<div
					style={{
						width: "100%",
						fontWeight: "bold",
						fontSize: "38px",
						lineHeight: "1",
						textAlign: "left",
						marginBottom: "52px",
						textAlign: "center",
					}}
				>
					{translate("login")}
               
				</div>

				<div style={{ width: "80%", maxWidth:'400px'}}>
					<TextField 
						fullWidth 
						type="email" 
						//label="이메일 주소" 
						className="loginInput loginEmailInput" 
						value={loginId || ''}
						placeholder={translate("login_email_placeholder")}
						//required
						//inputRef={emailFieldRef}
						onChange={(e) => setLoginId(e.target.value)}/>

					<div style={{height:"25px"}}></div>
					
					<TextField 
						fullWidth 
						type="password" 
						placeholder={translate("login_password_placeholder")}
						className="loginInputPw" 
						value={loginPassword || ''}
						//required
						inputRef={passwordFieldRef}
						onChange={onChangePassword}
						/>
				</div>

				<div
					style={{
						width: "80%",
						padding: "6px 0px",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						backgroundColor:'#ffffff',
						maxWidth:'400px'
					}}>
				{/* <div
					style={{
					fontSize: "14px",
					lineHeight: 1,
					color: "#56C79C",
					}}
				>
					영문자, 숫자, 특수문자를 포함한 8~35자 비밀번호를
					입력해주세요.
					<br />
					허용된 특수문자 :!@%$%^&*()+=._-
				</div> */}
				</div>

				<div style={{ width: "80%", maxWidth:'400px',marginBottom: "33px" }}>
					<div
						style={{
						width: "100%",
						display: "flex",
						alignItems: "center",
						marginBottom: "6px",
						}}
					>
						<input type="checkbox" style={{
							width: "18px",
							height: "19px",
							marginRight: "10px",
						}} checked={rememberID} onChange= {() => handleRememberIdClick()}
						// {() => setRememberID(!rememberID)}
						/>
						<span>{translate("Remember ID")}</span>
					</div>

					{/* <div
						style={{
						width: "100%",
						display: "flex",
						alignItems: "center",
						}}
					>
						<input
							type="checkbox"
							style={{
								width: "18px",
								height: "19px",
								marginRight: "10px",
							}}
							checked={autoLoginCheck}
							onChange={() => setAutoLoginCheck(!autoLoginCheck)}
						/>
						<span>자동 로그인</span>
					</div> */}
				</div>

				<div style={{ width: "80%", maxWidth:'400px',marginBottom: "20px" }}>
					<button
						style={{
						width: "100%",
						backgroundColor: "#5E2589",
						color: "#fff",
						fontSize: "17px",
						fontWeight: "600",
						border: "none",
						borderRadius: "4px",
						padding: "16px 0px",
						
						}}
						// onClick={clickSignIn}
					>
						{translate("login")}
					</button>
				</div>

				<div style={{ 
					width: "80%", 
					maxWidth:'400px',
					marginBottom: "20px", 
					display:'flex',
					flexDirection:'row', 
				}}>

					<a href={'https://kauth.kakao.com/oauth/authorize?client_id=78cf4589491e20a663b698ed24e88c75&redirect_uri='+ window.location.origin +'/oauth/handler&response_type=code&prompt=select_account'} style={{
						width: "100%",
						backgroundColor: "#FEE500",
						border: "1px solid grey",
						borderRadius: "4px",
						display:'flex',
						justifyContent:'center',
						alignItems:'center',
						color: "black",
						marginRight:'10px',
						padding:'10px',
					}} onClick={onClickKakao}>
						<img src='/kakao_logo.png' alt='kakao' style={{
							height:'20px',
              width:'20px'
						}}/> 
						&nbsp;&nbsp;
						<b>{translate("kakao_login")}</b>
					</a>

					{/* <button
						style={{
						width: "100%",
						backgroundColor: "white",
						color: "black",
						fontSize: "17px",
						fontWeight: "600",
						border: "1px solid grey",
						borderRadius: "4px",
						padding: "12px 0px",
						
						}}
						onClick={onClickGoogleLogin}
					>
						<img src={GoogleFontImage} alt="GoogleLogo" style={{height:'25px', marginRight:'10px'}}/>구글 로그인
					</button> */}

					<a href={'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + '790201023287-drqdkpol79dp8ir57fcugbsi47v7uiro.apps.googleusercontent.com' + '&redirect_uri='+ window.location.origin +'/oauth/handler' + '&response_type=code' + '&scope=email profile'} style={{
						width: "100%",
						backgroundColor: "white",
						border: "1px solid grey",
						borderRadius: "4px",
						display:'flex',
						justifyContent:'center',
						alignItems:'center',
						color: "black",
						padding:'10px'
					}} onClick={onClickGoogle}>
						<img src={GoogleFontImage} alt="google" style={{
							height:'23px'
						}}/> 
						&nbsp;&nbsp;
						<b>{translate("google_login")}</b>
					</a>
				</div>

				{/* <div style={{ 
					width: "80%", 
					maxWidth:'400px',
					marginBottom: "20px", 
					display:'flex',
					flexDirection:'row', 
					backgroundColor:'blue'
				}}> */}

				<div style={{ 
					width: "80%", 
					maxWidth:'400px',
					textAlign: "center", 
					display:'flex',
					flexDirection:'row', 
					justifyContent:'center'
				}}>
					<div style={{
						flex:1
					}}>
						<div
							style={{
								fontWeight: "600",
								fontSize: "16px",
								color: "black",
								cursor: "pointer",
							}}
							onClick={onClickSignUp}
						>
							{translate("signup")}
						</div>
					</div>
					<div style={{
						flex:1
					}}>
						<div style={{
							fontWeight: "600",
							fontSize: "16px",
							color: "black",
							cursor: "pointer",
						}}
							onClick={handleResetPasswordOpen}
						>
							{translate("reset_password")}
						</div>
						<ResetPasswordDialog
							//selectedValue={selectedValue}
							open={openRestPassword}
							onClose={handleClose}/>
					</div>
				</div>
            </form>
          )}
        </div>
      </div>
      {termAgreement ? <TermAgreement termAgreement={termAgreement} setTermAgreement={setTermAgreement} /> : null}
      {findId ? <FindIdModal findId={findId} setFindId={setFindId} /> : null}
      {changePW ? (
        <ChangePWModal changePW={changePW} setChangePW={setChangePW} />
      ) : null}


      <div
        className="modal fade"
        tabIndex="-1"
        aria-hidden="true"
        ref={forceModalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">강제 로그인</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeForceModal}
              />
            </div>

            <div className="modal-body">
              이미 다른 기기에서 로그인된 세션이 있습니다.
              <br />
              기존 세션을 종료하고 강제 로그인 하시겠습니까?
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={closeForceModal}>
                취소
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirmForceLogin}>
                강제 로그인
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default withRouter(Login);
